(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/services/assets/reducers/personal-result-reducer.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/services/assets/reducers/personal-result-reducer.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  createReducer
} = RTK;
const {
  FetchState
} = svs.components.marketplaceCompetition.constants;
const {
  fetchPersonalResultsAction,
  patchPersonalResultsAction
} = svs.components.marketplaceCompetition.services.actions.personalResultActions;
const personalResultState = {
  Competitions: {}
};
const getPersonalResultModel = (state, competitionId) => {
  if (!state.Competitions[competitionId]) {
    state.Competitions[competitionId] = {
      individual: undefined,
      teams: {}
    };
  }
  return state.Competitions[competitionId];
};
const getIndividualModel = (state, competitionId) => {
  const personalResults = getPersonalResultModel(state, competitionId);
  if (!personalResults.individual) {
    personalResults.individual = {
      data: {},
      lastFetch: null,
      status: FetchState.Idle
    };
  }
  return personalResults.individual;
};
const getTeamModel = (state, competitionId, teamId) => {
  const personalResults = getPersonalResultModel(state, competitionId);
  if (!personalResults.teams[teamId]) {
    personalResults.teams[teamId] = {
      data: {},
      lastFetch: null,
      status: FetchState.Idle
    };
  }
  return personalResults.teams[teamId];
};
const personalResultReducer = createReducer(personalResultState, builder => {
  builder.addCase(fetchPersonalResultsAction.pending, (state, action) => {
    const {
      competitionId,
      teamIds,
      shouldFetchIndividualResults
    } = action.meta.arg;
    if (shouldFetchIndividualResults) {
      const individualResult = getIndividualModel(state, competitionId);
      individualResult.status = FetchState.Pending;
    }
    teamIds.forEach(teamId => {
      const teamResult = getTeamModel(state, competitionId, teamId);
      teamResult.status = FetchState.Pending;
    });
  }).addCase(fetchPersonalResultsAction.fulfilled, (state, action) => {
    const newDateString = new Date().toISOString();
    const [individualResult, teamsResult] = action.payload;
    const {
      competitionId,
      teamIds,
      shouldFetchIndividualResults
    } = action.meta.arg;
    if (shouldFetchIndividualResults) {
      const individualResultModel = getIndividualModel(state, competitionId);
      individualResultModel.status = FetchState.Fulfilled;
      individualResultModel.lastFetch = newDateString;
      if (Object.keys(individualResult).length > 0) {
        individualResultModel.data = individualResult;
      }
    }
    teamIds.forEach(teamId => {
      if (Object.keys(teamsResult[teamId]).length > 0) {
        const teamResultModel = getTeamModel(state, competitionId, teamId);
        teamResultModel.status = FetchState.Fulfilled;
        teamResultModel.lastFetch = newDateString;
        teamResultModel.data = teamsResult[teamId];
      } else {
        delete state.Competitions[competitionId].teams[teamId];
      }
    });
  }).addCase(fetchPersonalResultsAction.rejected, (state, action) => {
    const {
      competitionId,
      teamIds,
      shouldFetchIndividualResults
    } = action.meta.arg;
    if (shouldFetchIndividualResults) {
      const individualResult = getIndividualModel(state, competitionId);
      individualResult.status = FetchState.Rejected;
    }
    teamIds.forEach(teamId => {
      const teamResult = getTeamModel(state, competitionId, teamId);
      teamResult.status = FetchState.Rejected;
    });
  }).addCase(patchPersonalResultsAction, (state, action) => {
    const {
      competitionId,
      data
    } = action.payload || {};
    if (!competitionId || !data) {
      return;
    }

    const {
      normalizePersonalResults
    } = svs.components.marketplaceCompetition.services.helpers;
    const [individualResult, teamsResult] = normalizePersonalResults(data);
    const newDateString = new Date().toISOString();
    if (individualResult) {
      const individualModel = getIndividualModel(state, competitionId);
      individualModel.data = _objectSpread(_objectSpread({}, individualModel.data), individualResult);
      individualModel.lastFetch = newDateString;
      individualModel.status = FetchState.Fulfilled;
    }
    Object.keys(teamsResult).forEach(teamId => {
      const teamData = teamsResult[teamId];
      const teamModel = getTeamModel(state, competitionId, teamId);
      teamModel.data = _objectSpread(_objectSpread({}, teamModel.data), teamData);
      teamModel.lastFetch = newDateString;
      teamModel.status = FetchState.Fulfilled;
    });
  });
});
setGlobal('svs.components.marketplaceCompetition.services.reducers.personalResultReducer', personalResultReducer);

 })(window);